import { ELianLianAccountStatus, IPaymentAccount, lianlianAccountStatusLabel } from '@core/main/types';
import { isNull } from '@core/tools';
import { computed, Ref } from 'vue';

interface IStatus {
  icon: string;
  iconColor: string;
  description: string;
  errorReason?: string;
}

export const lianlianAccountStatusStyle = {
  [ELianLianAccountStatus.Disabled]: 'danger',
  [ELianLianAccountStatus.Enabled]: 'success',
  [ELianLianAccountStatus.Applying]: 'primary',
  [ELianLianAccountStatus.ApplyFailed]: 'danger',
  [ELianLianAccountStatus.UnderApplying]: 'primary',
  [ELianLianAccountStatus.UnderVerifyed]: 'primary',
  [ELianLianAccountStatus.UnderNonPassAuth]: 'primary',
  [ELianLianAccountStatus.NonPassAuthOutDate]: 'danger',
  [ELianLianAccountStatus.LoggedOut]: 'danger',
};

export default function useLianWalletStatus(info: Ref<IPaymentAccount>) {
  const enabled = computed(() => info.value?.status === ELianLianAccountStatus.Enabled);
  const disabled = computed(() => info.value?.status === ELianLianAccountStatus.Disabled);

  const statusLabel = computed(() => isNull(info.value.status) ? '待申请' : lianlianAccountStatusLabel[info.value.status]);
  const statusStyle = computed(() => lianlianAccountStatusStyle[info.value.status] as any);
  const showCreateBtn = computed(() => {
    return !info.value.status ||
      info.value.status
      && !enabled.value
      && !info.value.showEditApply
      && !info.value.showReApply
      && ![
        ELianLianAccountStatus.Disabled,
        ELianLianAccountStatus.LoggedOut,
        ELianLianAccountStatus.Applying,
        ELianLianAccountStatus.UnderVerifyed,
        ELianLianAccountStatus.UnderNonPassAuth,
        ELianLianAccountStatus.NonPassAuthOutDate,
      ].includes(info.value.status);
  });

  const status = computed(() => {
    const s = info.value?.status;

    if (showCreateBtn.value) {
      return {
        icon: 'material-symbols:error-outline-rounded',
        iconColor: '#BFBFBF',
        description: '您还没有连连账户，请申请',
      };
    }

    let rs = {};

    switch (s) {
      case ELianLianAccountStatus.Enabled:
        break;
      case ELianLianAccountStatus.Disabled:
        rs = {
          icon: 'material-symbols:error-outline-rounded',
          iconColor: '#BFBFBF',
          description: '您的账户已禁用',
        };
        break;
      case ELianLianAccountStatus.UnderApplying:
        rs = {
          icon: 'majesticons:clock-line',
          iconColor: '#3194FA',
          description: '资料待提交',
        };
        break;
      case ELianLianAccountStatus.UnderVerifyed:
        rs = {
          icon: 'material-symbols:error-outline-rounded',
          iconColor: '#BFBFBF',
          description: '请进行短信验证',
        };
        break;
      case ELianLianAccountStatus.Applying:
        rs = {
          icon: 'majesticons:clock-line',
          iconColor: '#3194FA',
          description: '连连开户资料已提交，正在审核中...',
        };
        break;
      case ELianLianAccountStatus.ApplyFailed:
        rs = {
          description: '连连开户审核失败...',
          errorReason: info.value?.remark,
          icon: 'material-symbols:cancel-outline-rounded',
          iconColor: '#FF4948',
        };
        break;
      case ELianLianAccountStatus.UnderNonPassAuth:
        rs = {
          icon: 'majesticons:clock-line',
          iconColor: '#3194FA',
          description: '请进行免密授权',
        };
        break;
      case ELianLianAccountStatus.NonPassAuthOutDate:
        rs = {
          icon: 'material-symbols:error-outline-rounded',
          iconColor: '#BFBFBF',
          description: '免密授权已过期，请重新授权',
        };
        break;
      case ELianLianAccountStatus.LoggedOut:
        rs = {
          icon: 'material-symbols:error-outline-rounded',
          iconColor: '#BFBFBF',
          description: '您的账户已注销',
        };
        break;
      default:
        break;
    }

    return rs as IStatus;
  });

  return {
    status,
    statusLabel,
    statusStyle,
    showCreateBtn,
    enabled,
    disabled,
  };
}
